var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { placeholder: "升级包名称", clearable: "" },
            model: {
              value: _vm.searchData.name,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "name", $$v)
              },
              expression: "searchData.name"
            }
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              attrs: { placeholder: "设备型号", clearable: "", filterable: "" },
              model: {
                value: _vm.searchData.deviceTypeId,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "deviceTypeId", $$v)
                },
                expression: "searchData.deviceTypeId"
              }
            },
            _vm._l(_vm.deviceTypeCodeList, function(item, index) {
              return _c("el-option", {
                key: item.id,
                attrs: {
                  index: item.id,
                  label: item.name + "/" + item.code,
                  value: item.id
                }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              attrs: { placeholder: "升级模块", clearable: "", filterable: "" },
              model: {
                value: _vm.searchData.type,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "type", $$v)
                },
                expression: "searchData.type"
              }
            },
            _vm._l(_vm.typeList, function(item, index) {
              return _c("el-option", {
                key: item.value,
                attrs: {
                  index: item.value,
                  label: item.label,
                  value: item.value
                }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              attrs: {
                placeholder: "是否强制升级",
                clearable: "",
                filterable: ""
              },
              model: {
                value: _vm.searchData.isForce,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "isForce", $$v)
                },
                expression: "searchData.isForce"
              }
            },
            _vm._l(_vm.forceList, function(item, index) {
              return _c("el-option", {
                key: item.vaue,
                attrs: {
                  index: item.value,
                  label: item.label,
                  value: item.value
                }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              attrs: { placeholder: "升级范围", clearable: "", filterable: "" },
              model: {
                value: _vm.searchData.rangeType,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "rangeType", $$v)
                },
                expression: "searchData.rangeType"
              }
            },
            [
              _vm.isOverseas
                ? _vm._l(_vm.hwRangeList, function(item, index) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: {
                        index: item.value,
                        label: item.label,
                        value: item.value
                      }
                    })
                  })
                : _vm._l(_vm.rangeList, function(item, index) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: {
                        index: item.value,
                        label: item.label,
                        value: item.value
                      }
                    })
                  })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.fetchVersionJobList }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-refresh" },
              on: { click: _vm.onClickReset }
            },
            [_vm._v("重置")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "success", icon: "el-icon-plus" },
              on: {
                click: function($event) {
                  _vm.showDialog = true
                }
              }
            },
            [_vm._v("新增")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.list,
            stripe: "",
            border: "",
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "100" }
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumns, function(item, index) {
            return [
              _c("el-table-column", {
                key: index,
                attrs: {
                  label: item.label,
                  prop: item.prop,
                  formatter: item.formatter
                }
              })
            ]
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { width: "240", label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.onClickUpdate(scope.row)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(scope.row.auditStatus == 1 ? "查看" : "编辑")
                        )
                      ]
                    ),
                    _vm._v(" "),
                    scope.row.auditStatus == 1
                      ? _c(
                          "router-link",
                          {
                            attrs: {
                              to: "/ota/upgrade/situation/" + scope.row.id
                            }
                          },
                          [
                            _c(
                              "el-button",
                              { attrs: { type: "success", size: "mini" } },
                              [_vm._v("升级情况")]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.auditStatus == 0 &&
                    _vm.checkPermission(["app:version:examine"])
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "success", size: "mini" },
                            on: {
                              click: function($event) {
                                return _vm.onClickExamine(scope.row)
                              }
                            }
                          },
                          [_vm._v("审核")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("p"),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to:
                            "/ota/upgrade/compatibleVersion/" +
                            scope.row.id +
                            "/" +
                            scope.row.type +
                            "/" +
                            scope.row.deviceTypeId +
                            "/" +
                            scope.row.auditStatus
                        }
                      },
                      [
                        _c(
                          "el-button",
                          { attrs: { type: "info", size: "mini" } },
                          [
                            _vm._v(
                              _vm._s(
                                scope.row.auditStatus == 1
                                  ? "查看兼容版本"
                                  : "兼容版本"
                              )
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to:
                            "/ota/upgrade/upgradeContent/" +
                            scope.row.id +
                            "/" +
                            scope.row.auditStatus
                        }
                      },
                      [
                        _c(
                          "el-button",
                          { attrs: { type: "warning", size: "mini" } },
                          [_vm._v("更新内容")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p"),
                    _vm._v(" "),
                    scope.row.auditStatus == 1
                      ? [
                          _vm.checkPermission(["app:version:antiCheck"])
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "danger", size: "mini" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onClickDelete(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.auditStatus == 1
                                        ? "反审核"
                                        : "删除"
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      : [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "danger", size: "mini" },
                              on: {
                                click: function($event) {
                                  return _vm.onClickDelete(scope.row)
                                }
                              }
                            },
                            [_vm._v("删除")]
                          )
                        ]
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total > 0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.upgradeForm.id
              ? _vm.upgradeEdit
                ? "编辑"
                : "查看"
              : "新增",
            width: "600px",
            visible: _vm.showDialog,
            center: "",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showDialog = $event
            },
            close: _vm.onDialogClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "upgradeForm",
              attrs: {
                model: _vm.upgradeForm,
                rules: _vm.upgradeFormRule,
                "label-position": "left",
                "label-width": "130px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "升级任务名称", prop: "name", required: "" }
                },
                [
                  _c("el-input", {
                    attrs: {
                      readonly: _vm.editDisable,
                      placeholder: "升级任务名称",
                      clearable: ""
                    },
                    model: {
                      value: _vm.upgradeForm.name,
                      callback: function($$v) {
                        _vm.$set(_vm.upgradeForm, "name", $$v)
                      },
                      expression: "upgradeForm.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "设备型号",
                    prop: "deviceTypeId",
                    required: ""
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.editDisable,
                        placeholder: "设备型号",
                        clearable: "",
                        filterable: ""
                      },
                      on: { change: _vm.onDeviceTypeChange },
                      model: {
                        value: _vm.upgradeForm.deviceTypeId,
                        callback: function($$v) {
                          _vm.$set(_vm.upgradeForm, "deviceTypeId", $$v)
                        },
                        expression: "upgradeForm.deviceTypeId"
                      }
                    },
                    _vm._l(_vm.deviceTypeCodeList, function(item, index) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          index: item.id,
                          label: item.name + "/" + item.code,
                          value: item.id
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "升级模块", prop: "type", required: "" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: _vm.editDisable },
                      on: { change: _vm.onModuleTypeChange },
                      model: {
                        value: _vm.upgradeForm.type,
                        callback: function($$v) {
                          _vm.$set(_vm.upgradeForm, "type", $$v)
                        },
                        expression: "upgradeForm.type"
                      }
                    },
                    [
                      _c(
                        "el-radio",
                        {
                          staticStyle: { margin: "0 10px 0 0" },
                          attrs: { border: "", label: "1" }
                        },
                        [_vm._v("中心板模块")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          staticStyle: { margin: "0 10px 0 0" },
                          attrs: { border: "", label: "2" }
                        },
                        [_vm._v("WiFi板模块")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          staticStyle: { margin: "0 10px 10px 0" },
                          attrs: { border: "", label: "3" }
                        },
                        [_vm._v("语音板模块")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          staticStyle: { margin: "0 10px 0 0" },
                          attrs: { border: "", label: "4" }
                        },
                        [_vm._v("机芯板模块")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          staticStyle: { margin: "0 10px 0 0" },
                          attrs: { border: "", label: "5" }
                        },
                        [_vm._v("小腿板模块")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.hardwareLabel,
                    prop: "hardwareModuleId",
                    required: ""
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.editDisable,
                        placeholder: _vm.hardwareLabel,
                        clearable: "",
                        filterable: ""
                      },
                      on: { change: _vm.onHardwareModuleIdChange },
                      model: {
                        value: _vm.upgradeForm.hardwareModuleId,
                        callback: function($$v) {
                          _vm.$set(_vm.upgradeForm, "hardwareModuleId", $$v)
                        },
                        expression: "upgradeForm.hardwareModuleId"
                      }
                    },
                    _vm._l(_vm.hardwareList, function(item, index) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.moduleCode, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.versionLabel,
                    prop: "versionInfoId",
                    required: ""
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.editDisable,
                        placeholder: _vm.versionLabel,
                        clearable: "",
                        filterable: ""
                      },
                      model: {
                        value: _vm.upgradeForm.versionInfoId,
                        callback: function($$v) {
                          _vm.$set(_vm.upgradeForm, "versionInfoId", $$v)
                        },
                        expression: "upgradeForm.versionInfoId"
                      }
                    },
                    _vm._l(_vm.versionList, function(item, index) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.otaVersion, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "是否强制升级",
                    prop: "isForce",
                    required: ""
                  }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: _vm.editDisable },
                      model: {
                        value: _vm.upgradeForm.isForce,
                        callback: function($$v) {
                          _vm.$set(_vm.upgradeForm, "isForce", $$v)
                        },
                        expression: "upgradeForm.isForce"
                      }
                    },
                    [
                      _c(
                        "el-radio",
                        {
                          staticStyle: { margin: "0 10px 0 0" },
                          attrs: { border: "", label: "1" }
                        },
                        [_vm._v("是")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          staticStyle: { margin: "0 10px 0 0" },
                          attrs: { border: "", label: "0" }
                        },
                        [_vm._v("否")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "升级范围", prop: "rangeType", required: "" }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: _vm.editDisable },
                      model: {
                        value: _vm.upgradeForm.rangeType,
                        callback: function($$v) {
                          _vm.$set(_vm.upgradeForm, "rangeType", $$v)
                        },
                        expression: "upgradeForm.rangeType"
                      }
                    },
                    [
                      _vm.isOverseas
                        ? [
                            _c(
                              "el-radio",
                              {
                                staticStyle: { margin: "0 10px 0 0" },
                                attrs: { border: "", label: "1" }
                              },
                              [_vm._v("全域升级")]
                            )
                          ]
                        : [
                            _c(
                              "el-radio",
                              {
                                staticStyle: { margin: "0 10px 0 0" },
                                attrs: { border: "", label: "1" }
                              },
                              [_vm._v("全国升级")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-radio",
                              {
                                staticStyle: { margin: "0 10px 0 0" },
                                attrs: { border: "", label: "2" }
                              },
                              [_vm._v("区域升级")]
                            )
                          ],
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          staticStyle: { margin: "0 10px 0 0" },
                          attrs: { border: "", label: "3" }
                        },
                        [_vm._v("精准升级")]
                      )
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              parseInt(_vm.upgradeForm.rangeType) == 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "选择升级范围", required: "" } },
                    [
                      _c("el-cascader", {
                        attrs: {
                          disabled: _vm.editDisable,
                          options: _vm.regionList,
                          "collapse-tags": "",
                          props: {
                            multiple: true,
                            leaf: "children",
                            value: "name",
                            label: "name"
                          }
                        },
                        model: {
                          value: _vm.upgradeForm.rangeInfo,
                          callback: function($$v) {
                            _vm.$set(_vm.upgradeForm, "rangeInfo", $$v)
                          },
                          expression: "upgradeForm.rangeInfo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              parseInt(_vm.upgradeForm.rangeType) == 3
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "已选择设备", required: "" } },
                      [
                        _c(
                          "el-table",
                          {
                            ref: "deviceSelectedTable",
                            attrs: {
                              data: _vm.selectedList,
                              "header-cell-class-name": _vm.leftHeaderStyle,
                              border: "",
                              stripe: "",
                              "highlight-current-row": "",
                              "max-height": "300",
                              "row-key": _vm.getDeviceRowKey
                            },
                            on: {
                              "select-all": _vm.onDeviceSelectAllCancel,
                              select: _vm.onDeviceSelectCancel
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                type: "selection",
                                width: "55",
                                selectable: _vm.tableColumnSelectable,
                                "reserve-selection": ""
                              }
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.deviceTableColumns, function(
                              item,
                              index
                            ) {
                              return [
                                _c("el-table-column", {
                                  key: index,
                                  attrs: { prop: item.prop, label: item.label }
                                })
                              ]
                            })
                          ],
                          2
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "选择升级设备", required: "" } },
                      [
                        _c(
                          "div",
                          { staticClass: "filter-container" },
                          [
                            _c("el-input", {
                              staticClass: "filter-item",
                              staticStyle: { width: "200px" },
                              attrs: {
                                readonly: _vm.editDisable,
                                placeholder: "设备序列号",
                                clearable: ""
                              },
                              model: {
                                value: _vm.deviceSn,
                                callback: function($$v) {
                                  _vm.deviceSn = $$v
                                },
                                expression: "deviceSn"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  type: "primary",
                                  disabled: _vm.editDisable,
                                  icon: "el-icon-search",
                                  size: "mini"
                                },
                                on: { click: _vm.fetchDeviceList }
                              },
                              [_vm._v("查询")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-table",
                          {
                            ref: "deviceTable",
                            attrs: {
                              data: _vm.unSelectedList,
                              "header-cell-class-name": _vm.leftHeaderStyle,
                              border: "",
                              stripe: "",
                              "highlight-current-row": "",
                              "max-height": "300",
                              "row-key": _vm.getDeviceRowKey
                            },
                            on: {
                              "select-all": _vm.onDeviceSelectAll,
                              select: _vm.onDeviceSelect
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                type: "selection",
                                width: "55",
                                selectable: _vm.tableColumnSelectable,
                                "reserve-selection": ""
                              }
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.deviceTableColumns, function(
                              item,
                              index
                            ) {
                              return [
                                _c("el-table-column", {
                                  key: index,
                                  attrs: { prop: item.prop, label: item.label }
                                })
                              ]
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "版本说明",
                    prop: "description",
                    required: ""
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      readonly: _vm.editDisable,
                      clearable: "",
                      placeholder: "版本说明",
                      type: "textarea"
                    },
                    model: {
                      value: _vm.upgradeForm.description,
                      callback: function($$v) {
                        _vm.$set(_vm.upgradeForm, "description", $$v)
                      },
                      expression: "upgradeForm.description"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "text-align": "center" } },
                [
                  _c("el-button", { on: { click: _vm.onDialogClose } }, [
                    _vm._v("取消")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { disabled: _vm.editDisable, type: "primary" },
                      on: { click: _vm.onSubmitUpgradeInfo }
                    },
                    [_vm._v(_vm._s(_vm.upgradeForm.id ? "保存" : "新增"))]
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }